<template>
  <div id="vertical-navbar">
    <navbar-content />
  </div>
</template>
<script>
import NavbarContent from "@/components/modules/Layout/NavbarContent";
export default {
  name: "VerticalNavbar",
  components: {
    NavbarContent
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#vertical-navbar {
  background-color: #fff;
  height: 100vh;
  width: $vertical-navbar-width;
  min-width: $vertical-navbar-width;
  box-shadow: $basic-shadow;
  z-index: $Z-vertical-navbar;
}
</style>
